import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import { SOCIAL_LINKS } from "../data/siteContent";

function BehanceIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M7.803 5.908h4.396v1.815H7.803V5.908zm.049 8.037c.69 0 1.297-.179 1.82-.537.523-.358.928-.86 1.216-1.506.287-.646.43-1.402.43-2.268 0-.866-.143-1.622-.43-2.268a3.35 3.35 0 0 0-1.216-1.506c-.523-.358-1.13-.537-1.82-.537H5.908v8.612h1.944zm-.049-6.837h2.444c.456 0 .82.118 1.092.354.272.236.408.574.408 1.014 0 .44-.136.778-.408 1.014-.272.236-.636.354-1.092.354H7.803V7.108zm11.253 4.816c.33-.63.495-1.377.495-2.24 0-1.423-.402-2.548-1.206-3.375-.804-.827-1.917-1.24-3.339-1.24H13.08v12.043h3.926c1.49 0 2.656-.413 3.498-1.24.842-.827 1.263-1.978 1.263-3.453 0-.7-.165-1.327-.495-1.877zm-2.079 2.852c-.418.515-1.004.772-1.758.772h-2.069V8.235h2.069c.754 0 1.34.257 1.758.772.418.515.627 1.218.627 2.108 0 .89-.209 1.593-.627 2.108z" />
    </svg>
  );
}

const ICONS = {
  instagram: InstagramIcon,
  linkedin: LinkedInIcon,
  facebook: FacebookIcon,
  behance: BehanceIcon,
};

export default function SocialLinks({ className = "" }) {
  return (
    <div className={`flex gap-3 ${className}`}>
      {SOCIAL_LINKS.map(({ label, href, icon }) => {
        const Icon = ICONS[icon];
        const isMui = icon !== "behance";
        return (
          <a
            key={label}
            href={href}
            rel="noopener noreferrer"
            target="_blank"
            title={label}
            aria-label={label}
            className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/15 text-white/70 transition hover:border-accent hover:bg-white/5 hover:text-white"
          >
            {isMui ? (
              <Icon sx={{ fontSize: 22 }} />
            ) : (
              <Icon className="h-[22px] w-[22px]" />
            )}
          </a>
        );
      })}
    </div>
  );
}
